.searchBar {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  margin: 10px;
  background-color: var(--theme-button);
  height: auto;
  width: 280px;
  box-shadow: var(--theme-shadow-shallow);
  z-index: 11;
  border-radius: 4px;
}

.searchBarInput {
  padding: var(--spacer-2);
}

.searchBarResultsWrap {
  border-top: 1px solid var(--theme-light-border);
}
.searchBarResultsHeader {
  padding: 2px var(--spacer-1) 2px var(--spacer-4);
  color: var(--theme-tertiary-text);
  display: flex;
  align-items: center;
}
.searchBarResultsHeader p {
  margin: 0 auto 0 0;
  font-size: 12px;
}
.searchBarNavLink {
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--theme-primary-text);
  cursor: pointer;
  font-size: 18px;
  &.disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }
}
.searchBarResults {
  max-height: 310px;
  overflow: auto;
  padding: 0 var(--spacer-2) var(--spacer-2);
}
.searchBarResult {
  display: block;
  padding: var(--spacer-2);
  font-size: 13px;
  line-height: 14px;
  color: var(--theme-primary-text);
}
.searchBarResult,
.searchBarResult:hover {
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  padding: var(--spacer-2);
  border-radius: 4px;
}
.searchBarNoResults {
  padding: var(--spacer-4);
  font-size: 12px;
  line-height: 12px;
  color: var(--theme-tertiary-text);
}

.searchBarResult:hover {
  color: var(--aha-menu-item--color);
  background-color: var(--theme-menu-hover-background);
}
.searchBarResult.current {
  color: var(--theme-menu-highlighted-text);
  background-color: var(--theme-menu-active-background);
}
